import React from 'react';
import { useTranslation } from 'react-i18next';
import UnderConstruction from '../../component/ui/Common/UnderConstruction';
import styles from './GwReport.module.scss';

const GwReport = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.reportPage}>
      <div className="page-title p-16">{t('pageTitle.report')}</div>
      
      {/* 실제 페이지 콘텐츠 - 배경으로 보임 */}
      <div className={styles.reportContent}>
        <h2>Report</h2>
        <p>이 페이지에서는 시스템 리포트를 규격화하고 깔끔한 형태로 제공하여 보다 효율적인 분석이 가능하도록 합니다.</p>
        
        {/* 더미 콘텐츠 */}
        <div className={styles.statsContainer}>
          <div className={styles.statCard}>
            <h3>Report Generation</h3>
            <div className={styles.statValue}>- / -</div>
          </div>
          <div className={styles.statCard}>
            <h3>Template Status</h3>
            <div className={styles.statValue}>준비중</div>
          </div>
          <div className={styles.statCard}>
            <h3>Available Reports</h3>
            <div className={styles.statValue}>0</div>
          </div>
        </div>
      </div>
      
      {/* 공사중 표시 오버레이 */}
      <UnderConstruction />
    </div>
  );
};

export default GwReport;
